import { lazy } from "react";
import { Navigate } from "react-router-dom";

const OptimizationPerformanceLayout = lazy(
  () => import("pages/Planners/QueryOptimization/OptimizationPerformanceLayout")
);

const QueryOptimization = lazy(
  () => import("pages/Planners/QueryOptimization/QueryOptimizationROI/QueryOptimizationROI")
);

const SchemaChangeCost = lazy(
  () => import("pages/Planners/QueryOptimization/SchemaChangeCost/SchemaChangeCost")
);
const Migration = lazy(() => import("pages/Planners/QueryOptimization/Migration/Migration"));
const StorageCapacity = lazy(
  () => import("pages/Planners/QueryOptimization/StorageCapacity/StorageCapacity")
);

export const planners = [
  {
    path: "planners",
    // element: <Navigate to="planners" replace />,
    element: <OptimizationPerformanceLayout />,
  },
  {
    path: "planners",
    children: [
      // {
      //   path: "planners",
      //   element: <OptimizationPerformanceLayout />,
      // },
      {
        path: "query-optimization-roi",
        element: <QueryOptimization />,
      },
      {
        path: "schema-change-cost",
        element: <SchemaChangeCost />,
      },
      {
        path: "migration",
        element: <Migration />,
      },
      {
        path: "storage_capacity",
        element: <StorageCapacity />,
      },
    ],
  },
];
